
export default function ind_carryforward( state = [], action = {} ){

	switch( action.type ){
		case 'GET_CARRYFORWARS':
			return action.ind_carryforward
        case 'GET_CARRYFORWARS_USERS':
            return action.ind_carryforward
        case 'SAVE_CARRYFORWARS':
            return action.ind_carryforward
        case 'DELETE_CARRYFORWARS':
            return action.ind_carryforward
        case 'UPDATE_CARRYFORWARS':
            return action.ind_carryforward
		default: return state;
	}``
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/ind_carryforward/carry.reducer.js